import type { DayHours, NewDay } from '../types/hours'

export const weeklyHours: DayHours[] = [
  { day: 'Monday', hours: '9 AM – 2 PM', kind: 'new' },
  { day: 'Tuesday', hours: null, kind: 'closed' },
  { day: 'Wednesday', hours: '2 PM – 7 PM', kind: 'new' },
  { day: 'Thursday', hours: null, kind: 'closed' },
  { day: 'Friday', hours: null, kind: 'closed' },
  { day: 'Saturday', hours: '12 PM – 6 PM', kind: 'weekend' },
  { day: 'Sunday', hours: '12 PM – 6 PM', kind: 'weekend' },
]

export const newDays: NewDay[] = [
  {
    day: 'Monday',
    hours: '9 AM – 2 PM',
    description: 'Breakfast & lunch: coffee, tea, baked goods, wings and hearty bites.',
  },
  {
    day: 'Wednesday',
    hours: '2 PM – 7 PM',
    description:
      'An early-evening bite: udon, salads, chopped sandwiches, and the view.',
  },
]

export const hoursSummary = 'Mon 9 AM – 2 PM • Wed 2 PM – 7 PM • Sat & Sun 12 PM – 6 PM'
